import React from 'react';
import helpers from 'utils/helpers';
import Lock from '@mui/icons-material/Lock';

const currentPasswordInput = {
  label: 'Current password',
  type: 'password',
  yup: helpers.getYupRequired('Current password'),
  autocomplete: 'new-password',
  icon: <Lock/>,
};

export default currentPasswordInput;